import { Tooltip, Typography } from "@mui/material";
import { dateTimeFormat } from "constants/componentsConstants";
import dayjs from "configs/dayjs.config";
import React from "react";

export const TimeSince = ({
  startDate,
  variant,
  fontSize,
  colorIndicator = false,
}) => {
  if (!startDate) {
    return <div>-</div>;
  }

  let displayTime;
  displayTime = `${dayjs(startDate).format(dateTimeFormat.date)}`;
  return (
    <Tooltip title={dayjs(startDate).format(dateTimeFormat.date)}>
      {variant === "data" ? (
        <Typography component="span" fontSize={fontSize}>
          {dayjs(startDate).format(dateTimeFormat.date)}
        </Typography>
      ) : (
        <Typography component="span" fontSize={10}>
          {dayjs(startDate).format(dateTimeFormat.date)}
        </Typography>
      )}
    </Tooltip>
  );
};
